<template>
  <div class="pl-4 sm:pl-6 py-5">
    <h4 class="text-lg font-medium text-neutral-500">{{ label }}</h4>
    <div class="px-4 py-3 sm:px-6 space-y-3"><slot></slot></div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";

export default defineComponent({
  name: "LandingCardLinkSections",
  props: {
    label: {
      type: String,
      required: true,
    },
  },
});
</script>
